import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { RatingtypeModel } from 'projects/core/src/lib/models/ratingtype.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-ratingtype-list',
  templateUrl: './ratingtype-list.component.html',
  styleUrls: ['./ratingtype-list.component.scss']
})
export class RatingtypeListComponent extends BaseList implements OnInit {

  public ratingtypes: Array<RatingtypeModel> = [];
  public apiUrl = '/ratingtypes';

  protected rightLoad = 'admin.ratingtype.list';
  protected rightNew = 'admin.ratingtype.create';
  protected rightOpen = 'admin.ratingtype.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.ratingtypes'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('ratingtypes').subscribe({
      next: (ratingtypes: any) => {
        this.ratingtypes = [];
        ratingtypes.data.forEach((ratingtype: any) => {
          this.ratingtypes.push(new RatingtypeModel().deserialize(ratingtype));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
